import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PopoverDirective } from "./popover.directive";
import { Overlay, OverlayModule } from "@angular/cdk/overlay";
import { PopoverService } from "./popover.service";
import { PopovercontainerComponent } from "./popover-container/popover-container.component";

@NgModule({
  imports: [CommonModule, OverlayModule, PopovercontainerComponent],
  declarations: [PopoverDirective],
  exports: [PopoverDirective, PopovercontainerComponent],
  providers: [Overlay, PopoverService],
})
export class PopoverModule {}
